// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import VueScrollactive from 'vue-scrollactive'
import App from './ClientApp'
import store from './store'
import router from './router/client.index'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import UUID from 'vue-uuid'
import IdleVue from 'idle-vue-2'
import moment from 'moment'
import Tracker from '@openreplay/tracker'
import trackerAssist from '@openreplay/tracker-assist'
import VueSignaturePad from 'vue-signature-pad'
import { ConsoleLog } from '@openreplay/tracker/lib/common/messages'

Vue.config.productionTip = false

axios.defaults.baseURL = process.env.VUE_APP_APILOCATION

let urlParams = new URLSearchParams(window.location.search);

if (urlParams.has('clean')) {
  localStorage.clear()
} else {
  const token = localStorage.getItem('user-token')
  const expire = localStorage.getItem('user-token-expiry')
  const user = localStorage.getItem('user-name')
  const name = localStorage.getItem('user-full-name')
  if (token) {
    store.dispatch('auth/setSession', { token, expire, user, name, storage: true})
  }

}


const eventMonitor = new Vue()
const options = {
  eventEmitter: eventMonitor,
  idleTime: 3000
}

const tracker = new Tracker({
  projectKey: "AsPUUy0idqVZNj4Y9nwF",
  ingestPoint: "https://session.corp.caselocker.app/ingest",
  network: {
    capturePayload: true,
  },
  __DISABLE_SECURE_MODE: process.env.NODE_ENV !== "production"
})
tracker.use(trackerAssist())
import { mapGetters, mapMutations } from 'vuex'


Vue.mixin({
  data () {
    return {
      isProduction: (process.env.NODE_ENV === "production")
    }
  },
  computed: {
    ...mapGetters('auth', [
      'getDomainInfo',
    ]),
    app_name () {
      return this.getDomainInfo.app_name || null
    }
  },
  methods: {
    getTracker() {
      return tracker
    },
    startTracker(userInfo) {
      var domain = /:\/\/([^\/]+)/.exec(window.location.href)[1]
      tracker.stop()
      tracker.start({
        userID: userInfo['name'],
        metadata: {
          admin: 'false',
          client: 'true',
          dev: !this.isProduction,
          org: this.isProduction ? domain : 'localhost',
          username: userInfo['username'],
          user_id: userInfo['id'],
        }
      })
    },
    isMobileApp () {
      return window.ReactNativeWebView && window.ReactNativeWebView.postMessage !== undefined
    },
    postMobileMessage (message) {
      if (this.isMobileApp())
        window.ReactNativeWebView.postMessage(message)
    },
    documentTitle (subTitle) {
      if (this.getDomainInfo.app_name)
        document.title = subTitle + " | " + this.getDomainInfo.app_name
      else
        document.title = subTitle
    },
    convertToLocal (utc) {
      var stillUtc = moment.utc(utc).toDate()
      var local = moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss')
      return local
    },
    convertToCalRef (utc) {
      var stillUtc = moment.utc(utc).toDate()
      var local = moment(stillUtc).calendar()
      return local
    },
    convertToPeriodicRef (utc) {
      var stillUtc = moment.utc(utc).toDate()
      var local = moment(stillUtc).fromNow()
      return local
    },
    getSignResponse (status) {
      switch (status.toLowerCase()) {
        case 'created':
          return 'Waiting for others...'
        case 'sent':
          return 'Signature Requested'
        case 'delivered':
          return 'Opened'
        case 'signed':
        case 'completed':
          return 'Signed'
        case 'declined':
          return 'Declined to Sign'
        case 'autoresponded':
          return 'Failed to Deliver'
        case 'faxpending':
          return 'Fax Pending'
      }
    },
    convertToLocalWithoutTime (utc) {
      var stillUtc = moment.utc(utc).toDate()
      var local = moment(stillUtc).local().format('YYYY-MM-DD')
      return local
    },
  }
})

Vue.use(VueScrollactive)
Vue.use(Vuetify)
Vue.use(IdleVue, options)
Vue.use(UUID)
Vue.use(VueSignaturePad)

if (process.env.NODE_ENV === "production") {
  Vue.config.silent = true
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})
